import Api from '@/helpers/api';
/**
 * Obtiene la lista de formularios
 *
 * @returns {Promise<Form>} Promise - una promesa con la lista de formularios // Error
 */
const getAllForms = async () => {
    const result = await Api.get('/forms');
    return result.data;
};

/**
 * Obtiene un formulario, por su ID.
 *
 * @param {string} id - el Id del formulario
 * @returns {Promise<Form>} Promise una promesa con el estado del servicio // Error
 */
const getOneForm = async (id) => {
    const result = await Api.get(`/forms/${id}`);
    return result.data;
};

/**
 * Guarda un formulario
 *
 * @param {object} form - un objeto con los datos del formulario a guardar
 * @returns {Promise<Form>} Promise - una promesa con el estado del servicio // Error
 */
const saveForm = async (form) => {
    const result = await Api.post('/forms', form);
    return result.data;
};

/**
 * Actualiza un formulario
 *
 * @param {string} id - el Id del formulario
 * @param {object} form - un objeto con los datos del formulario a actualizar
 * @returns {Promise<Form>} Promise - una promesa con el estado del servicio // Error
 */
const updateForm = async (id, form) => {
    const result = await Api.put(`/forms/${id}`, form);
    return result.data;
};

/**
 * Elimina un formulario
 *
 * @param {string} id - el Id del formulario
 * @returns {Promise<Form>} Promise - una promesa con el estado del servicio // Error
 */
const deleteForm = async (id) => {
    const result = await Api.delete(`/forms/${id}`);
    return result.data;
};

/**
 * Copia un formulario
 *
 * @param {object} form - un objeto con los datos del formulario a copiar
 * @returns {Promise<Form>} Promise - una promesa con el estado del servicio // Error
 */
const copyForm = async (form) => {
    const result = await Api.post('/forms/copy', form);
    return result.data;
};

/**
 * Cierra un formulario
 *
 * @param {string} id - el Id del formulario
 * @param {object} form - un objeto con los datos del formulario a cerrar
 * @returns {Promise<Form>} Promise - una promesa con el estado del servicio // Error
 */
const closeForm = async (form) => {
    const result = await Api.post('/forms/close', form);
    return result.data;
};

/**
 * Activar un formulario
 *
 * @param {object} data - un objeto con los datos del formulario a activar {formID, groupID}
 * @returns {Promise<Form>} Promise - una promesa con el mensaje si la promesa se ha resulto satisfactoriamente.
 */
 const activeForm = async (data) => {
    const result = await Api.post('/forms/activate', data);
    return result.data;
};

export {
    getAllForms,
    getOneForm,
    saveForm,
    updateForm,
    deleteForm,
    copyForm,
    closeForm,
    activeForm
};
